import React, { useState } from 'react'
import './styles.scss'
import FormCheckout from 'features/Shop/components/FormCheckout'
import FormDiscount from 'features/Shop/components/FormDiscount'

function ShopCheckout() {
  const [validForm, setValidForm] = useState(false)
  const [formDataValue, setFormDataValue] = useState()
  const [showErrors, setShowErrors] = useState(false)
  return (
    <div className="frame-checkout">
      <h3>Shipment Details</h3>
      <div className="frame-checkout-form-left-right">
        <FormCheckout
          setValidForm={setValidForm}
          setFormDataValue={setFormDataValue}
          showErrors={showErrors}
        />
        <FormDiscount
          validForm={validForm}
          formDataValue={formDataValue}
          setShowErrors={setShowErrors}
        />
      </div>
    </div>
  )
}

export default ShopCheckout
